import { Component, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-chart-with-circle',
  templateUrl: './chart-with-circle.component.html',
  styleUrls: ['./chart-with-circle.component.scss']
})
export class ChartWithCircleComponent {
  isDesktop = window.innerWidth > 768;
  chart: any;
  canvas: any;
  @Input() id: any;
  @Input() Title: any;

  @Input() data: any = {};
  circleValues: any = {
    tina: 0,
    whatsapp: 0,
    others: 0,
  }
  ngAfterViewInit(): void {
    const canvasEl = document.getElementById(this.id) as HTMLCanvasElement;
    const ctx = canvasEl.getContext('2d');

    let chartStatus = Chart.getChart(this.id);
    if (chartStatus) {
      chartStatus.destroy();
    }

    if (!ctx) {
      console.error("Failed to get canvas context");
      return;
    }

    const gradientTina = ctx.createLinearGradient(0, 0, 0, 240);
    gradientTina.addColorStop(1, "rgba(18, 50, 63, 0.15)");
    gradientTina.addColorStop(0, "rgba(18, 50, 63, 0.52)");

    const gradientWhatsapp = ctx.createLinearGradient(0, 0, 0, 240);
    gradientWhatsapp.addColorStop(1, "rgba(10, 105, 135, 0.15)");
    gradientWhatsapp.addColorStop(0, "rgba(10, 105, 135, 0.52)");

    const gradientOthers = ctx.createLinearGradient(0, 0, 0, 240);
    gradientOthers.addColorStop(1, "rgba(240, 149, 12, 0.15)");
    gradientOthers.addColorStop(0, "rgba(240, 149, 12, 0.52)");

    const seriesColors = {
      tina: "#0099FF",
      whatsapp: "#77DC75",
      others: "#F0950C",
    };

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const valuesTina: number[] = [];
    const valuesWhatsapp: number[] = [];
    const valuesOthers: number[] = new Array(12).fill(0); // Initialize with 0 for each month

    let totalTina = 0, totalWhatsapp = 0, totalOthers = 0;

    if (this.data) {
      for (let i = 0; i < months.length; i++) {
        const month = months[i];
        const tinaValue = parseInt(this.data["Tina"]?.[month] || 0);
        const whatsappValue = parseInt(this.data["WhatsApp"]?.[month] || 0);

        valuesTina.push(tinaValue);
        valuesWhatsapp.push(whatsappValue);

        totalTina += tinaValue;
        totalWhatsapp += whatsappValue;

        // Sum all other sources
        let otherSum = 0;
        for (let source in this.data) {
          if (source !== "Tina" && source !== "WhatsApp") {
            otherSum += parseInt(this.data[source]?.[month] || 0);
          }
        }
        valuesOthers[i] = otherSum;
        totalOthers += otherSum;
      }

      const finalTotal = totalTina + totalWhatsapp + totalOthers;
      this.circleValues.tina = (totalTina / finalTotal) * 100;
      this.circleValues.whatsapp = (totalWhatsapp / finalTotal) * 100;
      this.circleValues.manual = (totalOthers / finalTotal) * 100;

      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: months,
          datasets: [
            {
              label: "Tina",
              data: valuesTina,
              pointRadius: 1,
              borderColor: seriesColors.tina,
              borderWidth: 1,
              backgroundColor: gradientTina,
              pointBackgroundColor: seriesColors.tina,
              pointBorderColor: seriesColors.tina,
            },
            {
              label: "WhatsApp",
              data: valuesWhatsapp,
              pointRadius: 1,
              borderColor: seriesColors.whatsapp,
              borderWidth: 1,
              backgroundColor: gradientWhatsapp,
              pointBackgroundColor: seriesColors.whatsapp,
              pointBorderColor: seriesColors.whatsapp,
            },
            {
              label: "Others",
              data: valuesOthers,
              pointRadius: 1,
              borderColor: seriesColors.others,
              borderWidth: 1,
              backgroundColor: gradientOthers,
              pointBackgroundColor: seriesColors.others,
              pointBorderColor: seriesColors.others,
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              labels: {
                usePointStyle: true,
                pointStyle: "line",
                generateLabels: (chart) =>
                  Chart.defaults.plugins.legend.labels.generateLabels(chart).map(
                    (item, index) => {
                      const dataset = chart.data.datasets[index];
                      const color = dataset.borderColor as string;
                      return {
                        ...item,
                        fillStyle: color,
                        strokeStyle: color,
                      };
                    }
                  ),
              },
            },
            filler: {
              propagate: false,
            },
            tooltip: {
              mode: "index",
              intersect: false,
              callbacks: {
                labelColor: (context) => {
                  const color = context.dataset.borderColor as string;
                  return {
                    borderColor: color,
                    backgroundColor: color,
                    borderWidth: 2,
                    borderRadius: 2,
                  };
                },
              },
            },
          },
          // aspectRatio: (this.isDesktop) ? 8.5 : undefined,
          scales: {
            y: {
              grid: { display: true },
              stacked: true
            },
            x: {
              grid: { display: true }
            }
          },
          interaction: {
            intersect: false,
          },
        }
      });
    }
  }


  sortData(object: Object) {
    const monthsOrder = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const sortedData = Object.fromEntries(
      Object.entries(object)
        .sort(([monthA], [monthB]) => monthsOrder.indexOf(monthA) - monthsOrder.indexOf(monthB))
    );
    return sortedData
  }
  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
